export const SET_USER_ADMIN = 'SET_USER_ADMIN'
export const SET_SIGNED_IN = 'SET_SIGNED_IN'
export const SET_USER = 'SET_USER'
